var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1668 12.6818C20.1668 12.1145 20.1149 11.5691 20.0184 11.0454H12.3301V14.14H16.7234C16.5342 15.14 15.9591 15.9872 15.0945 16.5545V18.5618H17.7327C19.2763 17.1691 20.1668 15.1181 20.1668 12.6818Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3302 20.5C14.5343 20.5 16.3821 19.7836 17.7327 18.5619L15.0945 16.5546C14.3636 17.0346 13.4285 17.3182 12.3302 17.3182C10.204 17.3182 8.40438 15.9109 7.76242 14.02H5.03516V16.0927C6.37842 18.7073 9.13908 20.5 12.3302 20.5Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7625 14.0199C7.59924 13.5399 7.5065 13.0272 7.5065 12.4999C7.5065 11.9727 7.59924 11.4599 7.7625 10.9799V8.90723H5.03524C4.48242 9.98723 4.16699 11.2091 4.16699 12.4999C4.16699 13.7908 4.48242 15.0127 5.03524 16.0927L7.7625 14.0199Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3302 7.68184C13.5286 7.68184 14.6047 8.08544 15.4507 8.87816L17.7921 6.5836C16.3784 5.29272 14.5305 4.5 12.3302 4.5C9.13907 4.5 6.37842 6.29272 5.03516 8.90728L7.76242 10.98C8.40438 9.08912 10.204 7.68184 12.3302 7.68184Z",
    fill: "#E94235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.fcb5133f7852e86eec4a9b4c262596bd.svg";
export { ForwardRef as ReactComponent };